import { useEffect, useRef, useState } from "react";
import { useInput } from "react-admin";
import ReactQuill from "react-quill";
import { formats, modules } from "./toolbarOptions";

import 'react-quill/dist/quill.snow.css';
import './index.scss';

const CustomEditor = ({ source, label, readOnly = false }) => {
  const { input } = useInput({ source: source });
  const [value, setValue] = useState("");
  const quillRef = useRef(null); // ✅ Store the actual Quill instance

  useEffect(() => {
    if (quillRef.current) {
      const quill = quillRef.current.getEditor();

      quill.on("selection-change", () => {
        const selection = quill.getSelection();
        if (selection) {
          const format = quill.getFormat(selection.index);
          if(!format.size) {
            console.log('>>>>>>>>SETT FORMAT SIZE>>>>>>')
            quill.format('size', '16px');
            const sizeDropdown = document.querySelector('.ql-picker.ql-size .ql-picker-label');
            if (sizeDropdown) {
              sizeDropdown.setAttribute('data-value', '16px');
            }
          }
        }
      });
    }
  }, []);

  useEffect(() => {
    if (input.value) {
      setValue(input.value);
    }
  }, [input.value]);

  const handleChange = (content, delta, source, editor) => {
    setValue(content);
    const html = editor.getHTML();
    input.onChange(html);
  };

  if (readOnly) {
    return (
      <div className="quill-readonly-container">
        {label? <label className="quill-label">{label}</label> : null}
        <ReactQuill
          value={value}
          readOnly={true}
          theme={null}
          modules={{ toolbar: false }}
          style={{
            border: 'none',
            padding: 0
          }}
        />
      </div>
    );
  }

  return (
    <>
      {label? <label className="quill-label">{label}</label> : null}
      <ReactQuill
        theme="snow"
        ref={quillRef}
        value={value}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        style={{
          height: "350px"
        }}
        preserveWhitespace={true}
      />
    </>
  );
};

export default CustomEditor;
